import { render } from "./QuizFormat.vue?vue&type=template&id=725ac2d8"
import script from "./QuizFormat.vue?vue&type=script&lang=js"
export * from "./QuizFormat.vue?vue&type=script&lang=js"

import "./QuizFormat.vue?vue&type=style&index=0&id=725ac2d8&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__